import { APIFactory } from '../api/api.factory'
const CommentsAPI = APIFactory.get('comments');
const ExpenseReportAPI = APIFactory.get('expenseReport')


export default {
    //get comments
    async getAllComments(erid, sectionType) {
        let params = '';
        let areaID = '';
        switch (sectionType) {
            case 'trip':
                areaID = 1;
                break;
            case 'air':
                areaID = 2;
                break;
            case 'lodging':
                areaID = 3;
                break;
            case 'meals':
                areaID = 4;
                break;
            case 'other':
                areaID = 5;
                break;
            case 'rental':
                areaID = 6;
                break;
            case 'review':
                areaID = 7;
                break;
            case 'misc':
                areaID = 8;
                break;
            case 'all':
                areaID = '';
                break;
            default:
                areaID = '';
        }
        params = `?sectionTypeId=${areaID}`

        let { data } = await CommentsAPI.get(erid, params);
        data = _.orderBy(data, ['id'], ['asc']);

        data.forEach(d => {
            d.showReply = false;
            d.replyComment = {
                expenseReportId: d.expenseReportId,
                expenseReportSectionTypeId: d.expenseReportSectionTypeId,
                text: null,
                parentCommentId: d.parentCommentId || d.id,
                isAddressed: false,
                isArchived: false
            }
        })
        return data;
    },
    async addComment(request, sectionType) {
        switch (sectionType) {
            case 'trip':
                request.ExpenseReportSectionTypeId = 1;
                break;
            case 'air':
                request.ExpenseReportSectionTypeId = 2;
                break;
            case 'lodging':
                request.ExpenseReportSectionTypeId = 3;
                break;
            case 'meals':
                request.ExpenseReportSectionTypeId = 4;
                break;
            case 'other':
                request.ExpenseReportSectionTypeId = 6;
                break;
            case 'rental':
                request.ExpenseReportSectionTypeId = 5;
                break;
            case 'review':
                request.ExpenseReportSectionTypeId = 7;
                break;
            case 'misc':
                request.ExpenseReportSectionTypeId = 8;
                break;
        }
        const { data } = await CommentsAPI.add(request);
        return data;
    },
    async submitApproval(erid) {
        const { data } = await ExpenseReportAPI.submitApproval(erid)
        return data;
    },
    async deny(erid) {
        const { data } = await ExpenseReportAPI.deny(erid)
        return data;
    },
    async pay(erid,payDate) {
        const { data } = await ExpenseReportAPI.pay(erid,payDate)
        return data;
    },
    async setPendingPaymentStatus(erid, statusTypeId) {
        const { data } = await ExpenseReportAPI.setPendingPaymentStatus(erid, statusTypeId)
        return data;
    },
    async getExpenseReportValidation(erid, sectionType) {
        let sectionTypeId = null;
        switch (sectionType) {
            case 'trip':
                sectionTypeId = 1;
                break;
            case 'air':
                sectionTypeId = 2;
                break;
            case 'lodging':
                sectionTypeId = 3;
                break;
            case 'meals':
                sectionTypeId = 4;
                break;
            case 'other':
                sectionTypeId = 6;
                break;
            case 'rental':
                sectionTypeId = 5;
                break;
            default:
                break;
        }
        const { data } = await ExpenseReportAPI.getExpenseReportValidation(erid, sectionTypeId);
        return data;
    },
    async getRedirectURL(expenseStatusId) {
        switch (expenseStatusId) {
            case 2:
                return '/pi-approval';
            case 3:
                return '/admin-approval';
            case 4:
                return '/admin2-approval';
            default:
                return null;
        }
    }
}